<template>
  <section class="template-summary">
    <div>
      <img :src="logisticProviderLogo" :alt="logisticProviderName" class="logistic-provider-logo" />
      <p v-if="templateName">{{ templateName }}</p>
      <p v-if="templateRowNumber">Linha do cabeçalho: <b>{{ templateRowNumber }}</b></p>
    </div>
    <hr/>
  </section>
</template>

<script>
import { Lodash } from '@intelipost-js/secure-providers';

export default {
  name: 'BillingTemplateSummary',
  props: {
    logisticProviderId: { type: Number },
    templateName: { type: String },
    templateRowNumber: { type: Number },
  },
  computed: {
    logisticProviderName() {
      return this.$store.getters['logisticProviders/logisticProviderName'](this.logisticProviderId);
    },
    logisticProviderLogo() {
      const { S3_ASSETS_URL } = process.env || {};
      return `${S3_ASSETS_URL}images/logistic_provider/${this.logisticProviderId}.png`;
    },
  },
  async created() {
    if (Lodash.isEmpty(this.$store.getters['logisticProviders/allDeliveryMethods'])) {
      await this.$store.dispatch('logisticProviders/getLogisticProviders', true);
    }
  },
};
</script>
<style scoped lang="scss">
.template-summary {
  p {
    font-size: 16px;
    line-height: 24px;
  }

  .logistic-provider-logo {
    width: 120px;
  }
}
</style>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-recon/features/billing/pages/templates/components/BillingTemplateSummary.vue